import { render, staticRenderFns } from "./LevelItem.vue?vue&type=template&id=79975068&scoped=true&"
import script from "./LevelItem.vue?vue&type=script&lang=ts&"
export * from "./LevelItem.vue?vue&type=script&lang=ts&"
import style0 from "./LevelItem.vue?vue&type=style&index=0&id=79975068&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79975068",
  null
  
)

export default component.exports